import axios, { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import { baseURL } from "./variables";

export const createApi = (token: string): AxiosInstance => {
    const api = axios.create({
        baseURL,
        headers: {
            "Content-Type": "application/json",
        }
    });

    api.interceptors.request.use(
        (config) => {
            if (token) config.headers.Authorization = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
        (response) => {
            if (response.config.method !== "get") {
                toast.success("Operação realizada com sucesso!");
            }
            return response;
        },
        (error) => {
            const status = error.response?.status;

            const msg =
                error.response?.data?.message ||
                (status === 401
                    ? "Não autorizado. Faça login novamente."
                    : "Ocorreu um erro ao processar sua solicitação.");

            toast.error(msg);
            return Promise.reject(error);
        }
    );

    return api;
};
